import React from 'react';
import {brandFont} from '../../brand';

export const InputPromptCard: React.FC<{
  filledText?: string;
  emptyHint?: string;
  filledOpacity?: number;
  emptyOpacity?: number;
}> = ({
  filledText,
  emptyHint = 'Paste or describe a workout to create a timer',
  filledOpacity = 0,
  emptyOpacity = 1,
}) => (
  <div
    style={{
      padding: 28,
      minHeight: 220,
      background: 'rgba(36,36,38,0.96)',
      borderRadius: 32,
      border: '1.5px solid rgba(255,255,255,0.05)',
      fontFamily: brandFont,
      fontSize: 26,
      lineHeight: 1.55,
      whiteSpace: 'pre-line',
      position: 'relative',
    }}
  >
    <div
      style={{
        position: 'absolute',
        inset: 28,
        color: 'rgba(255,255,255,0.34)',
        opacity: emptyOpacity,
      }}
    >
      {emptyHint}
    </div>
    {filledText ? (
      <div
        style={{
          color: 'rgba(255,255,255,0.94)',
          opacity: filledOpacity,
        }}
      >
        {filledText}
      </div>
    ) : null}
  </div>
);
